import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-label-print-dialog',
  templateUrl: './label-print-dialog.component.html',
  styleUrls: ['./label-print-dialog.component.css']
})
export class LabelPrintDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
